import { createSlice } from '@reduxjs/toolkit'

const dataProductSlice = createSlice({
  name: 'dataProduct',
  initialState: {
    data_type: null
  },
  reducers: {
    setDataType: (state, action) => {
      state.data_type = action.payload;
      
    }
  }
})

export const { setDataType } = dataProductSlice.actions;

export const dataProductReducer = dataProductSlice.reducer;
